import get from "./get";
import list from "./list";
import listErrors from "./errors/list";
import {combineReducers} from "redux";

export default combineReducers({list, get, listErrors});
// export default list;
